/**
 * manageCfg.roleManage.createRole Module
 *
 * Description
 */
'use strict';
angular.module('manageCfg.roleManageMent.editorcreateRole', [
    'manageCfg.roleManageMent.editOrCreateRoleRouter',
    'manageCfg.roleManageMent.editorcreateRole.changeGroup',
    'textOverflowModule'

    /* 'manageCfg.roleManageMent.editorcreateRole.copyAuthority'*/ // 废弃
])
    .controller('createRoleCtrl', ['$scope', '$sce', '$stateParams', '$state', '$timeout', 'trsHttpService', 'modalDialog', 'trsTransferService', 'trsspliceString', function($scope, $sce, $stateParams, $state, $timeout, trsHttpService, modalDialog, trsTransferService, trsspliceString) {
        // console.log($stateParams.type);
        /* if($stateParams.type=="edit"){
            $scope.roleDesc = $scope.roleData.ROLEDESC;
        }else{
            $scope.roleDesc = "";
        }*/
        initStatus();
        initData();
        if ($stateParams.type == 'create') {
            $scope.roleData.ROLEDESC = '';
        }
        $scope.changeGroup = function(obj) {
            $(obj.target).removeClass('role-btn-commen').addClass('role-btn-selected');
            $(obj.target).siblings().removeClass('role-btn-selected').addClass('role-btn-commen');
            $state.go('manageconfig.rolemanage.editorcreaterole.changegroup');
        };
        $scope.copyAuthority = function() {
            $state.go('manageconfig.rolemanage.editorcreaterole');
            trsTransferService.getRole('选择要复制权限的角色', $scope.realGroupObj.GROUPID, '', [], function(data) {
                var params = {
                    'serviceid': 'mlf_extrole',
                    'methodname': 'copyRoleRight',
                    'RoleId': $scope.roleData.ROLEID,
                    'RoleIds': trsspliceString.spliceString(data, 'ROLEID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('复制角色权限成功', '', 'success', false);
                    }
                );
            });
        };
        $scope.saveRole = function() {
            var params = {
                'ServiceId': 'mlf_extrole',
                'methodname': 'save',
                'RoleId': $scope.roleData.ROLEID,
                'GroupID': $scope.realGroupObj.GROUPID,
                'RoleName': $scope.roleData.ROLEDESC,
                'isDy': $scope.isDy
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.roleData.ROLENAME = $scope.roleData.ROLEDESC;
                $scope.roleData.ISDY = $scope.isDy;
                $scope.$emit('saveRole', $scope.roleData);
                modalDialog.alertType('保存成功', '', 'success', false);
            });
        };
        $scope.$watch('roleData', function(newV, oldV) {
            $scope.status.show = !!newV;
        });
        $scope.$on('changeGroup', function(event, data) {
            initStatus();
        });

        /**
         * [getOrgPath description]获取组织全路径
         * @param {[obj]} [groupObj] [description] 关于基础组织信息的对象
         * @return string [description] 组织的全路径
         */
        function getOrgPath() {
            var params = {
                serviceid: 'mlf_usermanagement',
                methodname: 'getRoleGroupPath',
                RoleId: $scope.roleData.ROLEID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.wholeGroupPath = data[0].ROLEGROUPPATH.replace(/>>/g, '-');
            });
        }

        /**
         * [initStatus description]初始化状态
         */
        function initStatus() {
            $scope.status = {};
            $scope.data = {};
        }

        /**
         * [initData description]初始化数据
         */
        function initData() {
            $scope.$watch('roleData', function(newV) {
                $scope.isDy = newV.ISDY;
                if (newV) {getOrgPath();}
            });
        }

        /**
         * [isDyChecked description] 大样选中校验
         * @return {Boolean} [description]
         */
        $scope.isDyChecked = function() {
            return $scope.isDy === 'true';
        };

        /**
         * [selectDy description] 勾选大样
         * @return {[type]} [description]
         */
        $scope.selectDy = function() {
            $scope.isDy = $scope.isDy === 'true' ? 'false' : 'true';
        };
    }]);
